export const ADDITION_PROPERTY = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加租金损失保险条款<br>大地财险（备-家财）〔2015〕附4号',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，由于发生主险责任范围内的事故，导致与被保险人签订房屋租赁合同的承租人无法在主险合同载明的地址内居住，被保险人因此发生的租金损失 保险人按本附加险合同的约定负责赔偿。'
                }
            ]
        },
        {
            intro: '赔偿限额与免赔天数',
            list: [
                { order: '第二条', context: '本附加险的日租金赔偿限额、累计赔偿限额及每次事故绝对免赔天数由投保人与保险人双方协商确定，并在保险单中载明。' }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                { order: '第三条', context: '被保险人请求赔偿时，应向保险人提供保险事故发生时有效的房屋租赁合同、租金收入证明，以及投保人或被保险人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。' },
                { order: '第四条', context: '保险事故发生后，保险人按下列公式计算租金损失赔偿金额：', details: [
                    { text: '赔偿金额=日租金金额×赔偿天数' },
                    { text: '日租金金额以保险事故发生前，被保险人与承租人签订的房屋租赁合同中载明的租金金额按日均计算，最高不超过保险单载明的日租金赔偿限额。' },
                    { text: '赔偿天数为保险事故发生后，被保险人遭受租金损失 之日起至主险保险财产修复或被保险人恢复租金收入（以 先发生者为准）之日止的天数扣除保险单中载明的每次事 故绝对免赔天数。' }
                ] },
                { order: '第五条', context: '在保险期间内，不论发生一次或多次保险事故，实际赔偿金额达到保险单中载明的本附加险累计赔偿限额时，本附加险责任终止。' },
                { order: '第六条', context: '保险事故发生后，被保险人应及时进行修复，不得拖延。对于故意拖延期间的租金损失，保险人不承赔偿责任。' }
            ]
        },
        {
            intro: '其他事项',
            list: [ { order: '第七条', context: '本附加险条款未尽事宜，以主险条款的约定为 准；本附加险条款与主险条款若有相抵触之处，以本附加 险条款的约定为准。' } ]
        }
    ]
}